import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StepService } from '../services/steps/step.service';

export const AuthFlowGuard: CanActivateFn = (route) => {

  const stepService = inject(StepService);
  const router = inject(Router);

  const requiredStep = route.data['requiredStep'];
  const currentStep = stepService.currentStep;


  if (currentStep < requiredStep) {
    router.navigate(['/auth/create-new-account']);
    return false;
  }

  return true;
};